import axios from "axios";
import { config } from "src/config";
import { getIdToken } from "src/client";
import { PaymentDetails } from "src/types/payment-details";
import { BuildingInput } from "src/types/buildings-input";
const { paymentApi, serverUrl } = config

export class PaymentService {
  public getClientSecret = async (amount: number, currency: string) => {
    const url = `${paymentApi}/init`;
    const res = await axios.post(url, { amount, currency });
    return res.data;
  }

  public listPaymentHistory = async (): Promise<any> => {
    try {
      const Authorization = 'Bearer ' + getIdToken();
      const paymentHistory = await axios.get(
        serverUrl + "payment/invoices",
        {
          headers: 
          { 
            Authorization 
          }
        }
      );
      return paymentHistory.data;
    } catch (err) {
      return [];
    }
  };

  public listNextInvoice = async (): Promise<any> => {
    try {
      const Authorization = 'Bearer ' + getIdToken();
      const nextInvoice = await axios.get(
        serverUrl + "payment/invoices/next",
        {
          headers: 
          { 
            Authorization 
          }
        }
      );
      return nextInvoice.data;
    } catch (err) {
      return {}
    }
  }

  public listPaymentDetails = async (): Promise<PaymentDetails> => {
    try {
      const Authorization = 'Bearer ' + getIdToken();
      const paymentDetails = await axios.get(
        serverUrl + "payment/account",
        {
          headers: 
          { 
            Authorization 
          }
        }
      );
      return paymentDetails.data;
    } catch (err) {
      return new PaymentDetails();
    }
  };

  public savePaymentDetails = async (paymentDetails: PaymentDetails): Promise<any> => {
    try {
      const Authorization = 'Bearer ' + getIdToken();
      const data = await axios.put(
        serverUrl + "payment/account",
        paymentDetails,
        {
          headers: 
          { 
            Authorization 
          }
        }
      );
      return data;
    } catch (err) {
      throw new Error('Payment updated error');
    }
  };

  public subscribeCustomer = async (data: BuildingInput[]): Promise<any> => {
    try {
      const Authorization = 'Bearer ' + getIdToken();
      await axios.post(
        serverUrl + "payment/subscription",
        {
          buildings: data
        },
        {
          headers: 
          { 
            Authorization 
          }
        }
      );
      return {};
    } catch (err) {
      return {};
    }
  };
}
